/*
 * types/services/dr2am.locales.proto
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: version not set
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 2.4.21
 *
 * Do not edit the class manually.
 *
 */

import {ApiClient} from '../ApiClient';

/**
 * The ServiceAddLocaleLanguageRequest model module.
 * @module model/ServiceAddLocaleLanguageRequest
 * @version version not set
 */
export class ServiceAddLocaleLanguageRequest {
  /**
   * Constructs a new <code>ServiceAddLocaleLanguageRequest</code>.
   * @alias module:model/ServiceAddLocaleLanguageRequest
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>ServiceAddLocaleLanguageRequest</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/ServiceAddLocaleLanguageRequest} obj Optional instance to populate.
   * @return {module:model/ServiceAddLocaleLanguageRequest} The populated <code>ServiceAddLocaleLanguageRequest</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new ServiceAddLocaleLanguageRequest();
      if (data.hasOwnProperty('name'))
        obj.name = ApiClient.convertToType(data['name'], 'String');
    }
    return obj;
  }
}

/**
 * @member {String} name
 */
ServiceAddLocaleLanguageRequest.prototype.name = undefined;


